import axios from "axios";
import { FETCH_CAISSES_FAILURE, FETCH_CAISSES_REQUEST, FETCH_CAISSES_SUCCESS, FETCH_CAISSES_SUCCESS_2, FETCH_CAISSE_FAILURE, FETCH_CAISSE_REQUEST, FETCH_CAISSE_SUCCESS } from "../../app/actions/actions";
import { baseurl } from "../../utils/url/baseurl";
import { getAndCheckLocalStorage } from "../../utils/storage/localvalueFuction";
import { localStorageData, localStorageKeys } from "../../utils/storage/localvalue";
import { profileRoleType } from "../../utils/dataApi/dataFormApi";
import { getDataFromFile } from "../DataLocal";
import { toast } from "react-toastify";


// Récupérer tous les codes promo
export function fetchCaissesAll(startDate, endDate, vehicle, property, reservation, createdBy) {
    return async (dispatch) => {

        const params = new URLSearchParams();
        if (startDate) params.append("start", startDate);
        if (endDate) params.append("end", endDate);
        if (reservation) params.append("reservation", reservation);
        if (createdBy) params.append("createdBy", createdBy);
        if (property) params.append("property", property);
        if (vehicle) params.append("vehicle", vehicle);

        const caissesAll = getDataFromFile(localStorageData.CaisseAll) || [];
        dispatch({ type: FETCH_CAISSES_SUCCESS, payload: caissesAll })
        dispatch({ type: FETCH_CAISSES_SUCCESS_2, payload: caissesAll })
        dispatch({ type: FETCH_CAISSES_REQUEST });
        await axios.get(`${baseurl.url}/api/v1/caisses/get_caisses?${params.toString()}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            console.log(response.data.data);
            dispatch({ type: FETCH_CAISSES_SUCCESS, payload: response.data.data });
            dispatch({ type: FETCH_CAISSES_SUCCESS_2, payload: response.data.data });
        }).catch((error) => {
            //console.log(error);
            dispatch({ type: FETCH_CAISSES_FAILURE, payload: error.message });
        });
    }
}






// Récupérer un code promo par ID
export function fetchCaisseById(idCaisse) {
    return async (dispatch) => {
        dispatch({ type: FETCH_CAISSE_REQUEST });
        await axios.get(`${baseurl.url}/api/v1/caisses/get_caisse/${idCaisse}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            //console.log(response.data.data);
            dispatch({ type: FETCH_CAISSE_SUCCESS, payload: response.data.data });
        })
            .catch((error) => {
                dispatch({ type: FETCH_CAISSE_FAILURE, payload: error.message })
                //console.log(error);
            });
    }
}






// Créer un nouveua message 
export function createCaisse(data) {
    return async (dispatch) => {
        dispatch({ type: FETCH_CAISSE_REQUEST });
        await axios.post(`${baseurl.url}/api/v1/caisses/create`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            //console.log(response.data.data);
            dispatch({ type: FETCH_CAISSE_SUCCESS, payload: response.data.data });
            toast.success(response?.data?.message || "Opération éffectué avec succès", { position: "bottom-right" });
            dispatch(fetchCaissesAll("", "", "", "", "", getAndCheckLocalStorage(localStorageKeys.userId)));

            if (getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN) {
            } else {
                dispatch(fetchCaissesAll("", "", "", "", "", getAndCheckLocalStorage(localStorageKeys.userId)));
            }
        }).catch((error) => {
            dispatch({ type: FETCH_CAISSE_FAILURE, payload: error.message });
            toast.error(error?.response?.data.message || "Operation non éffectué", { position: "bottom-right" });
            if (getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN) {
            } else {
                dispatch(fetchCaissesAll("", "", "", "", "", getAndCheckLocalStorage(localStorageKeys.userId)));
            }
            //console.log(error);
        });
    }
}






// Créer un nouveua message 
export function sendMessageCaisse(data, toast) {
    return async (dispatch) => {
        dispatch({ type: FETCH_CAISSE_REQUEST });
        await axios.post(`${baseurl.url}/api/v1/caisses/send-response`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            //console.log(response.data.data);
            dispatch({ type: FETCH_CAISSE_SUCCESS, payload: response.data.data });
            toast.success(response?.data?.message || "Message envoyé avec succès", { position: "bottom-right" });
            if (getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER) {
            } else {
                fetchCaissesAll();
            }
        }).catch((error) => {
            dispatch({ type: FETCH_CAISSE_FAILURE, payload: error.message });
            toast.error(error?.response?.data.message || "Message non envoyé", { position: "bottom-right" });
            if (getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER) {
            } else {
                fetchCaissesAll();
            }
            //console.log(error);
        });
    }
}
